import * as types from './mutation-types'
const mutations = {
    [types.SET_REVIEW](state, review) {
        state.review = review
    },
    [types.UPDATA_FOLLOW](state, follow) {
        if (state.follow.indexOf(follow) === -1) {
            state.follow.push(follow)
        } else {
            state.follow.splice(state.follow.indexOf(follow), 1)
        }
    },
    [types.UPDATA_LOAD](state, review) {
        state.showLoad = review
    },
    changeFundNoticeInfo(state, info) {
        state.fundNoticeInfo = info;
        console.log(state.fundNoticeInfo);
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js